import { render, staticRenderFns } from "./Privilege.vue?vue&type=template&id=1cc2d684&"
import script from "./Privilege.vue?vue&type=script&lang=js&"
export * from "./Privilege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports